
export const imageStyles = {
  replace_pattern: 'sites/default/files',

  backround_sizes: {
    screen: '100vw',
    thumbnail: '2em',
  },
  backround_sizes_img: ['325w', '650w', '1024w', '1300w'],
  background_sizes_webp: [
    'sites/default/files/styles/max_325x325/public',
    'sites/default/files/styles/max_650x650/public',
    'sites/default/files/styles/max_1024x1024/public',
    'sites/default/files/styles/max_1300x1300/public',
  ],
  background_default: 'sites/default/files/styles/max_650x650/public'
};
